import { render, staticRenderFns } from "./RTWCStep2.vue?vue&type=template&id=640a5f44&scoped=true&lang=pug"
import script from "./RTWCStep2.vue?vue&type=script&lang=ts"
export * from "./RTWCStep2.vue?vue&type=script&lang=ts"
import style0 from "./RTWCStep2.vue?vue&type=style&index=0&id=640a5f44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a5f44",
  null
  
)

export default component.exports